export default "__VITE_ASSET__Dudaa_Of__"